<template>
  <v-menu bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        outlined
        :elevation="0"
        class="mt-1 px-1"
        style="min-width: 30px"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small>mdi-arrow-down-bold</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item v-for="opcion in opciones" :key="opcion.id" link @click="clickOpcion (opcion)">
        <v-list-item-icon class="mr-1">
          <v-icon>{{ opcion.icono }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t (opcion.titulo) }}</v-list-item-title>
      </v-list-item>
    </v-list>

  </v-menu>

</template>

<script>
import { JSON_stringify } from '@/util';

export default {
  props: {
    TablaDatosApi: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      opciones: [
        { id: "pdf-h", icono: "mdi-file-pdf-box", titulo: "PDF (horizontal)" },
        { id: "pdf-v", icono: "mdi-file-pdf-box", titulo: "PDF (vertical)" },
        { id: "csv", icono: "mdi-file-delimited-outline", titulo: "CSV" },
        { id: "tsv", icono: "mdi-file-delimited", titulo: "TSV" },
        { id: "html", icono: "mdi-language-html5", titulo: "HTML" },
        { id: "txt", icono: "mdi-format-columns", titulo: "Texto" },
        { id: "json", icono: "mdi-code-json", titulo: "JSON" },
      ]
    }
  },
  methods: {
    clickOpcion (opcion) {
      let parametros = {
        url_base_backend: process.env.VUE_APP_URL_BASE_BACKEND,
        tabla: this.TablaDatosApi.tabla,
        campos: this.TablaDatosApi.camposInterno,
        opciones: this.TablaDatosApi.opcionesConsultaTablaVista(),
        titulo: this.TablaDatosApi.titulo,
        formato: opcion.id
      };

      let url = process.env.VUE_APP_URL_BASE_BACKEND + "/descargar_tabla?accessToken=" + encodeURIComponent (this.$store.accessToken) + "&parametros=" + encodeURIComponent (btoa (JSON_stringify (parametros)));
      window.open(url, '_blank').focus();
    }
  }
}
</script>

<style>

</style>